const escCallbacks: Set<() => void> = new Set();

const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
        escCallbacks.forEach((cb) => cb());
    }
};

if (typeof window !== "undefined" && !(window as any).__escHandlerInitialized) {
    window.addEventListener("keydown", handleKeyDown);
    (window as any).__escHandlerInitialized = true;
}

export function addEscHandler(callback: () => void): () => void {
    escCallbacks.add(callback);
    return () => {
        escCallbacks.delete(callback);
    };
}